'use client'

export function isExternalLink(url: string): boolean {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
        return false
    }

    try {
        const urlObj = new URL(url)
        const hostname = urlObj.hostname
        const internalDomains = ['khanoumi.com', 'www.khanoumi.com']

        return !internalDomains.includes(hostname)
    } catch (e) {
        return false
    }
}
